<template>
    <div>
        <div v-if="vuex_admin.admin_group_id == 3 && vuex_admin.admin_group_id == 2"></div>
        <div v-else>
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="_save()">添加</el-button>
        </div>
        <el-table v-loading="datas.status == -1" :data="datas.data" @sort-change="_sort" @selection-change="_select">
            <el-table-column width="150" align="center" fixed label="操作">
                <template slot-scope="scope">
                    <div class="handle-box">
                        <el-button type="text" @click="_save(scope.row.id)">详情</el-button>
                        <el-button type="text" @click="_del(scope.row.id)" class="c-danger"
                            v-if="vuex_admin.id == scope.row.admin_id">删除</el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="投标单位">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.title }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="报名费" align="center">
                <template slot-scope="scope">
                    <div>
                        <span v-if="scope.row.is_bmf">√</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="保证金" align="center">
                <template slot-scope="scope">
                    <div>
                        <span v-if="scope.row.is_bzj">√
                            <span v-if="!scope.row.bzj_pic" class="c-danger">【未上传保证金退还凭证】</span>
                        </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="是否中标" align="center">
                <template slot-scope="scope">
                    <div>
                        <span v-if="scope.row.is_zb">√</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="是否可以退还保证金" align="center">
                <template slot-scope="scope">
                    <div>
                        <span v-if="scope.row.is_bzj_can">√
                        </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="是否已经退还保证金" align="center">
                <template slot-scope="scope">
                    <div>
                        <span v-if="scope.row.is_bzj_th">√
                            <span v-if="!scope.row.bzj_pic_th" class="c-danger">【未上传保证金退还凭证】</span>
                        </span>
                    </div>
                </template>
            </el-table-column>
            <template v-for="(item, index) in mix_fields">
                <el-table-column :label="item.COLUMN_COMMENT" :width="item.width ? item.width : 'auto'" :key="index">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row[item.COLUMN_NAME] }}
                        </div>
                    </template>
                </el-table-column>
            </template>
        </el-table>
        <ls-mask title="保证金凭证" @close="show_bzj = false" v-if="show_bzj" width="500px">
            <el-form>
                <el-form-item label="退还凭证" v-if="bzj_code">
                    <ls-upload v-model="r.bzj_pic_th"></ls-upload>
                </el-form-item>
                <el-form-item label="凭证" v-else>
                    <ls-upload v-model="r.bzj_pic"></ls-upload>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="_bzj_pic">上传</el-button>
                </el-form-item>
            </el-form>
        </ls-mask>
        <ls-table-data :table="table" @fields="e => { mix_fields = e }"></ls-table-data>
        <ls-mask v-if="show_save" @close="show_save = false" :title="r.id ? '编辑' : '新增'" width="800px">
            <el-form>
                <el-form-item label="投标单位">
                    <el-input v-model="r.title" :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="报价/万">
                    <el-input v-model="r.bj" :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="报名费">
                    <el-switch v-model="r.is_bmf" :active-value="1" :inactive-value="0" :disabled="disabled">
                    </el-switch>
                </el-form-item>
                <el-form-item label="保证金">
                    <el-switch v-model="r.is_bzj" :active-value="1" :inactive-value="0"
                        :disabled="disabled && vuex_admin.admin_group_id != 3">
                    </el-switch>
                </el-form-item>
                <el-form-item label="保证金凭证">
                    <ls-upload v-model="r.bzj_pic" :disabled="disabled && vuex_admin.admin_group_id != 3"></ls-upload>
                </el-form-item>
                <el-form-item label="是否中标">
                    <el-switch v-model="r.is_zb" :active-value="1" :inactive-value="0" :disabled="disabled">
                    </el-switch>
                </el-form-item>
                <el-form-item label="是否可以退还保证金">
                    <el-switch v-model="r.is_bzj_can" :active-value="1" :inactive-value="0" :disabled="disabled">
                    </el-switch>
                </el-form-item>
                <el-form-item label="是否退还保证金">
                    <el-switch v-model="r.is_bzj_th" :active-value="1" :inactive-value="0"
                        :disabled="disabled && vuex_admin.admin_group_id != 3">
                    </el-switch>
                </el-form-item>
                <el-form-item label="退还保证金日期">
                    <el-date-picker type="date" v-model="r.date_th" align="center" value-format="yyyy-MM-dd"
                        :disabled="disabled && vuex_admin.admin_group_id != 3">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="退还保证金凭证">
                    <ls-upload v-model="r.bzj_pic_th"
                        :disabled="disabled && vuex_admin.admin_group_id != 3"></ls-upload>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="r.remark" :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="投标文件">
                    <div v-if="r.file">
                        旧的文件： <a :href="r.file" target="_blank">
                            查看
                        </a>
                    </div>
                    <ls-upload-files v-model="r.files" :disabled="disabled"></ls-upload-files>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="_submit">提交</el-button>
                </el-form-item>
            </el-form>
        </ls-mask>
    </div>
</template>
<script>
export default {
    props: {
        pro_id: {
            default: 0
        },
        admin: {
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            table: 'pro_tb',
            datas: {
                add: {
                    pro_id: this.pro_id
                }
            },
            r: {
                files: []
            },
            r_add: {
                pro_id: this.pro_id
            },
            show_bzj: false,
            bzj_code: 0
        };
    },
    computed: {
        disabled() {
            if (!this.r.id) {
                return false;
            }
            if (this.vuex_admin.admin_group_id == 1) {
                return false;
            }
            if (this.r.admin_id == this.vuex_admin.id) {
                return false;
            }
            return true;
        }
    },
    created() {
        this._load();
    },
    methods: {
        _show_bzj(id, code) {
            this.bzj_code = code;
            this.$http.post('pro_tb/show', {
                id,
                code
            }).then(res => {
                if (res.code) {
                    this.r = res.data;
                    this.show_bzj = true;
                }
            })
        },
        _bzj_pic() {
            this.$http.post('pro_tb/bzj_pic', {
                ...this.r,
                code: this.bzj_code
            }).then(res => {
                if (res.code) {
                    this.show_bzj = false;
                    this._load();
                }
            })
        }
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>